import Long from "long";

let fallbackCounter = 0;
let counterView: Int32Array | null = null;

if (typeof SharedArrayBuffer !== "undefined" && typeof Atomics !== "undefined") {
  counterView = new Int32Array(new SharedArrayBuffer(4));
}

export const uuid = (): Long => {
  if (counterView) {
    return Long.fromNumber(Atomics.add(counterView, 0, 1) + 1, true);
  }
  fallbackCounter++;
  return Long.fromNumber(fallbackCounter, true);
};
